import React, { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CustomCursor from "../components/CustomCursor";
import SEO from "../components/SEO";
import DataShieldGame from "../components/DataShieldGame";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const lenis = new Lenis();
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="bg-[var(--ink)] text-[var(--cream)] min-h-screen">
      <SEO title="Privacy Policy" description="Privacy Policy for Meraki Solutions." />
      {/* <CustomCursor /> */}
      <Navbar />
      
      <main className="pt-44 pb-32">
        <div className="container-xl px-4 md:px-6 max-w-4xl mx-auto">
          <h1 className="font-display text-4xl md:text-7xl mb-12 balance">Privacy <span className="italic gold-text">Policy</span></h1>
          <div className="space-y-8 text-[var(--cream-muted)] leading-relaxed font-body">
            <section>
              <h2 className="text-xl text-[var(--gold)] font-impact tracking-widest uppercase mb-4">1. Data Collection</h2>
              <p>We collect minimal information required to provide our cinematic and digital services. This includes your name, email, and project briefs shared via our contact forms.</p>
            </section>
            <section>
              <h2 className="text-xl text-[var(--gold)] font-impact tracking-widest uppercase mb-4">2. Usage of Information</h2>
              <p>Your data is used strictly for communication and project management. We do not sell or share your personal information with third-party advertisers.</p>
            </section>
            <section>
              <h2 className="text-xl text-[var(--gold)] font-impact tracking-widest uppercase mb-4">3. Security</h2>
              <p>We implement industry-standard encryption to protect your project briefs and personal details. Our studio takes intellectual property and data privacy with the utmost seriousness.</p>
            </section>
            <section>
              <h2 className="text-xl text-[var(--gold)] font-impact tracking-widest uppercase mb-4">4. Contact</h2>
              <p>For any privacy-related inquiries, please reach out to us at info@meraki-solutions.in.</p>
            </section>
          </div>
        </div>
      </main>

      <DataShieldGame />

      <Footer />
    </div>
  );
};

export default Privacy;
